import gql from 'graphql-tag';

import MenuImageFragment from './fragments/menu-image';

export default gql`
  query allImages(
    $comboWhere: ComboFilter
    $itemWhere: ItemFilter
    $offerWhere: OfferFilter
    $pickerWhere: PickerFilter
    $rewardWhere: RewardFilter
  ) {
    allCombos(where: $comboWhere) {
      ... on Combo {
        _id
        image {
          ...MenuImageFragment
        }
      }
    }
    allItems(where: $itemWhere) {
      ... on Item {
        _id
        image {
          ...MenuImageFragment
        }
      }
    }
    allPickers(where: $pickerWhere) {
      ... on Picker {
        _id
        image {
          ...MenuImageFragment
        }
      }
    }
    allOffers(where: $offerWhere) {
      ... on Offer {
        _id
        localizedImage {
          en {
            app {
              ...MenuImageFragment
            }
          }
          fr {
            app {
              ...MenuImageFragment
            }
          }
        }
      }
    }
    allRewards(where: $rewardWhere) {
      ... on Reward {
        _id
        image {
          en {
            ...MenuImageFragment
          }
        }
      }
    }
  }
  ${MenuImageFragment}
`;
